import moment from 'utils/moment';
import noDataDefault from './no-data-default.svg';
import noData1 from './no-data-1.svg';
import noData2 from './no-data-2.svg';
import noData3 from './no-data-3.svg';
import noData4 from './no-data-4.svg';
import noData5 from './no-data-5.svg';
import noData6 from './no-data-6.svg';
import noDataConfirm from './no-data-confirm.svg';
import noDataCheckIn from './no-data-check-in.svg';

export enum CALENDAR_VIEW_TYPE {
  DAY_VIEW = 'DAY_VIEW',
  WEEK_VIEW = 'WEEK_VIEW',
  MONTH_VIEW = 'MONTH_VIEW',
}

export const CALENDAR_TIME_SET = {
  open: moment().set({ hour: 9, minute: 0, second: 0 }),
  close: moment().set({ hour: 21, minute: 0, second: 0 }),
};

/**
 * Trang thai ticket, mirror GlobalConstant.StatusBill ben main-rest-api.
 * Card appointment doi icon check-in sang icon PAID khi ticket o trang thai CLOSED.
 */
export enum BillStatus {
  PENDING = -1,
  OPEN = 0,
  CLOSED = 1,
  VOID = 2,
  REFUND = 3,
  CAPTURE_EPX = 4,
  ERROR = 5,
  DELETE = 6,
  MERGED = 7,
}

export const APPOINTMENT_SOURCE_TYPE = {
  WEBSITE: 1,
  CALl_IN: 0
};

export const ColorSets = {
  default: {
    background: '#FFFFFF',
    aptBg: '#FFFFFF',
    stroke: '#95B8D1',
    shadow: '#0D446C',
    text: '#1D2129',
    bottomBG: noData1,
  },
  0: {
    background: '#E5E3E6',
    aptBg: '#E5E3E6',
    stroke: '#E5E3E6',
    shadow: '#7D7573',
    text: '#1D2129',
    bottomBG: noDataDefault,
  },
  1: {
    background: '#809BCE',
    aptBg: '#EEF4FF',
    stroke: '#EEF4FF',
    shadow: '#809BCE',
    text: '#1D2129',
    bottomBG: noData1,
  },
  2: {
    background: '#E4D3E7',
    aptBg: '#E4D3E7',
    stroke: '#E4D3E7',
    shadow: '#482986',
    text: '#1D2129',
    bottomBG: noData2,
  },
  3: {
    background: '#FDFEDB',
    aptBg: '#FDFEDB',
    stroke: '#FDFEDB',
    shadow: '#F4F439',
    text: '#1D2129',
    bottomBG: noData3,
  },
  4: {
    background: '#E6FAE2',
    aptBg: '#E6FAE2',
    stroke: '#E6FAE2',
    shadow: '#6AC45F',
    text: '#1D2129',
    bottomBG: noData4,
  },
  5: {
    background: '#F2CEE6',
    aptBg: '#F2CEE6',
    stroke: '#F2CEE6',
    shadow: '#A63272',
    text: '#1D2129',
    bottomBG: noData5,
  },
  6: {
    background: '#FFFFFF',
    aptBg: '#FFFFFF',
    stroke: '#EEF4FF',
    shadow: '#0D446C',
    text: '#1D2129',
    bottomBG: noData6,
  },
};

export const StatusColorSets = {
  confirm: {
    background: '#0CB76F',
    aptBg: '#0CB76F',
    stroke: '#A3E7BE',
    shadow: '#D6EADF',
    text: '#FFF',
    bottomBG: noDataConfirm,
  },
  checkIn: {
    background: '#148CF1',
    aptBg: '#148CF1',
    stroke: '#BEE1FF',
    shadow: '#cfe8feff',
    text: '#FFF',
    bottomBG: noDataCheckIn,
  },
};

// Swatches offered when creating a staff group. Fixed rather than a free color picker: one tap on a
// tablet, and `readableTextOn` picks each label colour, so no swatch can leave text unreadable.
//
// Muted tones chosen for the product. Measured against the label `readableTextOn` picks (white for
// all but amber, which takes dark ink), the ratios are: blue 5.11, grey 4.83, purple 4.57, amber
// 4.42, red 4.32, green 4.07, orange 4.04, teal 4.03. Five sit under the 4.5:1 bar for body text and
// all sit over the 3:1 bar for large text and UI components; the floor asserted in
// src/utils/color-contrast.test.ts matches that reality rather than a standard the palette does not
// meet. Teal is the tightest at 4.03 — nudging it lighter is what would trip the test first.
export const STAFF_GROUP_COLORS = [
  '#B96A3D', // orange
  '#4A6FA5', // blue
  '#C05B54', // red
  '#4F8A65', // green
  '#7D6BAF', // purple
  '#3E8A8A', // teal
  '#A5803C', // amber
  '#6B7280', // grey
];

export const STAFF_CALENDAR_PAGE_SIZE = 12;
export const STAFF_CALENDAR_PAGE_ZOOM_SIZE = 15;